import classNames from "classnames/bind";
import styles from "./HistoryView.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { handleHistoryView } from "~/hooks/function";
const cx = classNames.bind(styles);
function HistoryView() {
    console.log("HistoryView");
    const historySave = JSON.parse(localStorage.getItem("history")) || [];
    historySave.reverse();
    historySave.length > 20 && (historySave.length = 20);
    return (
        <>
            {historySave.length > 0 ? (
                historySave.map((car) => (
                    <Link
                        key={car.ID}
                        className={cx("wrapper")}
                        to={car.link}
                        onClick={() => handleHistoryView(car)}
                    >
                        <img
                            loading="lazy"
                            className={cx("car_avatar")}
                            src={car.avatar}
                            alt={car.brand + " " + car.name + " " + car.version}
                        />
                        <div className={cx("car_info")}>
                            <h4 className={cx("car_name")}>{car.name}</h4>
                            <span className={cx("car_description")}>
                                <span className={cx("car_brand")}>
                                    <FontAwesomeIcon icon={faCircle} />
                                    <span>{car.brand}</span>
                                </span>
                            </span>
                        </div>
                    </Link>
                ))
            ) : (
                <div className={cx("no_result")}>
                    Dạo 1 vòng xem siêu xe đi !!!
                </div>
            )}
        </>
    );
}
export default HistoryView;
